export default __webpack_public_path__ + "static/media/teach-hero.6b86c734.jpeg";